{
  "labels": {
    "textSingleLine": "テキスト（1 行）",
    "textMultipleLines": "テキスト（複数行）",
    "date": "日付",
    "trueFalse": "はい／いいえ",
    "singleDocument": "単一の書類",
    "multiDocument": "複数の書類",
    "number": "数値",
    "eMail": "メールアドレス",
    "phone": "電話",
    "dropDownSingleSelectList": "ドロップダウン（単一選択）",
    "dropDownMultiSelectList": "ドロップダウン（複数選択）",
    "comboBox": "コンボボックス",
    "timestamp": "タイムスタンプ",
    "featureLink": "機能へのリンク"
  },
  "descriptions": {
    "openTextFieldSingleLine": "自由入力欄（1 行）",
    "openTextFieldMultipleLines": "自由入力欄（複数行）",
    "formatMmDdYyyy": "形式：MM/DD/YYYY",
    "toggleButton": "トグルボタン",
    "singleFileUploadField": "ファイルアップロード欄（1 ファイル）",
    "multipleFileUploadField": "ファイルアップロード欄（複数ファイル）",
    "numericInputField": "数値入力欄",
    "emailAddressInputField": "メールアドレス入力欄",
    "format1XxxXxxXxxx": "形式：+1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "リストから 1 つ選択",
    "selectMultipleOptionsFromAList": "リストから複数選択",
    "singleOptionDropDownListOpenTextField": "単一選択のドロップダウンリスト＋自由入力欄",
    "dateAndTimeFields": "日付と時刻の入力欄",
    "linkToTheFormFeatures": "フォーム機能へのリンク"
  }
}
